import Helpers from "./Helpers";

export default class Response {
	/**
	 * HTTP response status code
	 */
	status?: number;

	/**
	 * Response 'action to' format
	 */
	action?: string = undefined;

	/**
	 * Exception response details
	 */
	exception: any;

	/**
	 * Response status success
	 */
	success: boolean = false;

	/**
	 * Response friendly message
	 */
	message?: string = undefined;

	/**
	 * Response data payload
	 */
	data: any = undefined;

	/**
	 * Response input validation felds errors
	 */
	errors?: object = undefined;

	/**
	 * Define HTTP status code response
	 *
	 * @param status
	 */
	setStatus(status: number) {
		this.status = status;
	}

	/**
	 * Get HTTP status code
	 *
	 * @return
	 */
	getStatus(): number | undefined {
		return this.status;
	}

	/**
	 * Verify input has error
	 *
	 * @param key
	 * @return
	 */
	inputHasError(key: string): boolean {
		if (!this.errors) {
			return false;
		}

		return this.errors.hasOwnProperty(key);
	}

	/**
	 * Get data payload by key
	 *
	 * @param key
	 * @return
	 */
	getData(key: string): any {
		if (!this.data) {
			return null;
		}

		if (!this.data.hasOwnProperty(key)) {
			return null;
		}

		return this.data[key] || null;
	}

	/**
	 * Serialize object to JSON string
	 *
	 * @return
	 */
	toJson(): string {
		return Helpers.objectToJson(this);
	}
}
